export default "__VITE_ASSET__B$lwX7I4__"